import { QuestionBase } from './question-base';
import { Subscription } from 'rxjs';

/*

Sample:

new TextboxQuestion({
  key: 'name',
  label: 'nouns.name',
  // value: 'Peter',
  required: true,
  order: 1
}),

*/
export class NumberQuestion extends QuestionBase<number> {
  controlType = 'number';
  error: string;
  errorSubscription: Subscription = new Subscription();

  constructor(options: any = {}) {
    super({ ...options, designSystem: true });

    const { error: err = null } = options;
    this.errorSubscription = err ? err.subscribe((err: string) => (this.error = err)) : new Subscription();
  }

  onDeleteQuestion() {
    super.onDeleteQuestion();
    this.errorSubscription.unsubscribe();
  }
}
